import { Box } from "@material-ui/core";
import { closeOverlayAndReset, CreateServiceTicketActiveScreen } from "../redux/UIOverlayCreateServiceTicketRedux";
import { useAppDispatch } from "../reduxhooks";
import { useEffect } from "react";
import { Order, OrderItem } from "common-ts/dist/models/Orders";
import SignUpStart from "./OverlayViewCreateServiceTicket0SignUpStart";
import OrderSelect from "./OverlayViewCreateServiceTicket1OrderSelect";
import ProductSelect from "./OverlayViewCreateServiceTicket2ProductSelect";
import ServiceInput from "./OverlayViewCreateServiceTicket3ServiceInput";
import Confirmation from "./OverlayViewCreateServiceTicket4Confirmation";

export interface FlowSelectionData {
    isSignedIn: boolean;
}

export interface FlowStateData {
    currentScreen: CreateServiceTicketActiveScreen;
    selectedOrder: Order | null;
    selectedProducts: OrderItem[];
}

export interface FlowStateCallback {
    delayedDispatch: (currentScreen: CreateServiceTicketActiveScreen) => void;
    setSelectedOrder: (selectedOrder: Order) => void;
    setSelectedProducts: (selectedProducts: OrderItem[]) => void;
    createServiceTicketDispatch: (description: any[]) => void;
}

export function FlowComponentMaster(
    flowSelectionData: FlowSelectionData,
    flowStateData: FlowStateData,
    flowStateCallback: FlowStateCallback
) {
    let children: JSX.Element[] = [];
    children = FlowComponentMensTops(flowSelectionData, flowStateData, flowStateCallback);

    return (
        <Box>
        {
            children
        }
        </Box>
    );
}

function FlowComponentMensTops(
    flowSelectionData: FlowSelectionData,
    flowStateData: FlowStateData,
    flowStateCallback: FlowStateCallback
) {
    const dispatch = useAppDispatch();
    const delayedDispatch = flowStateCallback.delayedDispatch;
    let children: JSX.Element[] = [];

    useEffect(() => {
        if (flowSelectionData.isSignedIn && flowStateData.currentScreen === CreateServiceTicketActiveScreen.SignUpStart) {
            delayedDispatch(CreateServiceTicketActiveScreen.OrderSelect);
        }
    }, [])

    switch (flowStateData.currentScreen) {
        case CreateServiceTicketActiveScreen.SignUpStart:
            children.push(
                <SignUpStart 
                    handleBack={() => {
                        dispatch(closeOverlayAndReset());
                    }}
                    handleNext={() => {
                        delayedDispatch(CreateServiceTicketActiveScreen.OrderSelect);
                    }}
                    isSignedIn={flowSelectionData.isSignedIn}
                />
            );
            children.push(
                <Box style={{width: '100%', height: '80px'}}></Box>
            );
            break;

        case CreateServiceTicketActiveScreen.OrderSelect:
            children.push(
                <OrderSelect
                    handleBack={() => {
                        if (flowSelectionData.isSignedIn) {
                            return;
                        }
                        delayedDispatch(CreateServiceTicketActiveScreen.SignUpStart);
                    }}
                    handleNext={() => {
                        delayedDispatch(CreateServiceTicketActiveScreen.ProductSelect);
                    }}
                    setSelectedOrder={flowStateCallback.setSelectedOrder}
                />
            );
            break;

        case CreateServiceTicketActiveScreen.ProductSelect:
            children.push(
                <ProductSelect
                    handleBack={() => {
                        delayedDispatch(CreateServiceTicketActiveScreen.OrderSelect);
                    }}
                    handleNext={() => {
                        delayedDispatch(CreateServiceTicketActiveScreen.ServiceInput);
                    }}
                    selectedOrder={flowStateData.selectedOrder!}
                    setSelectedProducts={flowStateCallback.setSelectedProducts}
                />
            );
            break;

        case CreateServiceTicketActiveScreen.ServiceInput:
            children.push(
                <ServiceInput
                    handleBack={() => {
                        delayedDispatch(CreateServiceTicketActiveScreen.ProductSelect);
                    }}
                    handleNext={(desc: any[]) => {
                        flowStateCallback.createServiceTicketDispatch(desc);

                        delayedDispatch(CreateServiceTicketActiveScreen.Confirmation);
                    }}
                    selectedProducts={flowStateData.selectedProducts}
                />
            );
            break;

        case CreateServiceTicketActiveScreen.Confirmation:
            children.push(
                <Confirmation />
            );
            break;        
    }

    // TODO
    return children;
}